import { ReactNode } from "react";
import styled from "styled-components";

type FieldLabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  mandatory?: boolean;
  children: ReactNode;
};

const FieldLabelStyled = styled.span`
  position: relative;
  margin-bottom: 1rem;
  padding-left: 1.2rem;
  font-weight: 700;
  line-height: 2.2rem;

  ::before {
    position: absolute;
    top: 0.8rem;
    left: 0;
    width: 0.6rem;
    height: 0.6rem;
    background-color: #000;
    border-radius: 100%;
    content: "";
  }

  em {
    font-size: 1.4rem;
    color: #e10032;
    font-weight: 400;
  }
`;

const FieldLabel = ({ mandatory = false, children, ...props }: FieldLabelProps) => {
  return (
    <>
      <FieldLabelStyled {...props}>
        {children}
        {(mandatory && <em> (필수)</em>) || " (선택)"}
      </FieldLabelStyled>
    </>
  );
};

export default FieldLabel;
